import React, { useEffect, useState } from "react";
import { Button, Form, Row, Col } from "react-bootstrap";
import { documentsValidationSchema } from "./validations";
import { useFormik } from "formik";
import LoadingSpinner from "../../Components/spinner";
import { useNavigate, useParams, useLocation } from "react-router-dom";

const Documents = ({
  formikRef,
  handlePreviousTab,
  submitEntireForm,
  setDocumentsValues,
}) => {
  const navigate = useNavigate();
  const location = useLocation();
  const { id } = useParams();
  const fromProfile = location.state?.fromProfile;
  const [loading, setLoading] = useState(false);
  const formik = useFormik({
    initialValues: {
      documentName: "",
      documentType: "",
      document: "",
      remarks: "",
    },
    validationSchema: documentsValidationSchema,
    onSubmit: async (values) => {
      try {
        setLoading(true);
        await submitEntireForm({});
      } catch (error) {
        console.log("Error upon Employee form", error);
      } finally {
        setLoading(false);
      }
    },
  });

  const onPressPrevious = async () => {
    const errors = await formik.validateForm();
    if (Object.keys(errors).length > 0) {
      formik.setTouched(errors);
      return;
    }
    handlePreviousTab();
  };
  useEffect(() => {
    formikRef.current.documents = formik;
  }, [formik]);
  return (
    <Form>
      <Row className="g-3">
        <Col md={12}>
          <Form.Group className="mb-3">
            <Form.Label>Upload Document</Form.Label>
            <Form.Control
              type="file"
              data-testid="uploadDocument"
              className="bg-dark text-light border-light"
              onChange={(event) => {
                formik.setFieldValue(
                  "document",
                  event.currentTarget.files[0] || null
                );
                setDocumentsValues((prev) => ({
                  ...prev,
                  document: event.currentTarget.files[0] || null,
                }));
              }}
              onBlur={() => formik.setFieldTouched("document", true)}
            />
            {formik.touched.document && formik.errors.document && (
              <div className="text-danger">{formik.errors.document}</div>
            )}
          </Form.Group>
        </Col>
      </Row>
      <Row>
        <Col md={6}>
          <Form.Group className="mb-3">
            <Form.Label>Document Name</Form.Label>
            <Form.Control
              type="text"
              data-testid="documentName"
              className="bg-dark text-light border-light input-placeholder-light"
              {...formik.getFieldProps("documentName")}
              onChange={(event) => {
                formik.setFieldValue("documentName", event.currentTarget.value);
                setDocumentsValues((prev) => ({
                  ...prev,
                  documentName: event.currentTarget.value,
                }));
              }}
              isInvalid={
                formik.touched.documentName && !!formik.errors.documentName
              }
            />
            <Form.Control.Feedback type="invalid">
              {formik.errors.documentName}
            </Form.Control.Feedback>
          </Form.Group>
        </Col>
        <Col md={6}>
          <Form.Group className="mb-3">
            <Form.Label>Document Type</Form.Label>
            <Form.Select
              data-testid="documentType"
              className="bg-dark text-light border-light"
              {...formik.getFieldProps("documentType")}
              onChange={(event) => {
                formik.setFieldValue("documentType", event.currentTarget.value);
                setDocumentsValues((prev) => ({
                  ...prev,
                  documentType: event.currentTarget.value,
                }));
              }}
              isInvalid={
                formik.touched.documentType && !!formik.errors.documentType
              }
            >
              <option value="">Please select</option>
              <option value="ID Card">ID Card</option>
              <option value="Resume">Resume</option>
              <option value="Passport">Passport</option>
              <option value="Contract">Contract</option>
            </Form.Select>
            <Form.Control.Feedback type="invalid">
              {formik.errors.documentType}
            </Form.Control.Feedback>
          </Form.Group>
        </Col>
      </Row>
      <Row className="g-3">
        <Col md={12}>
          <Form.Group className="mb-3">
            <Form.Label>Remarks</Form.Label>
            <Form.Control
              as="textarea"
              data-testid="remarks"
              rows={3}
              className="bg-dark text-light border-light input-placeholder-light"
              {...formik.getFieldProps("remarks")}
              onChange={(event) => {
                formik.setFieldValue("remarks", event.currentTarget.value);
                setDocumentsValues((prev) => ({
                  ...prev,
                  remarks: event.currentTarget.value,
                }));
              }}
            />
          </Form.Group>
        </Col>
      </Row>
      <div className="container-fluid mt-4">
        <div className="d-flex justify-content-end">
          <Button
            variant="danger"
            onClick={() => {
              if (fromProfile && id) {
                navigate(`/EmployeeProfile/${id}`);
              } else {
                navigate("/employees");
              }
            }}
            className="mb-4 ml-2"
          >
            Exit
          </Button>
          {loading ? (
            <LoadingSpinner size={"md"} />
          ) : (
            <Button
              variant="success"
              className="mb-4 ml-2"
              onClick={() => {
                formik.handleSubmit();
              }}
            >
              Save Documents
            </Button>
          )}
        </div>
      </div>
    </Form>
  );
};
export default Documents;
